/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getProductsByItemPartNumberAsync } from './SearchItemsDataActionExtension.g';
import { IITSSearchItemPartResponse } from './SearchItemsDataServiceEntities.g';
/**
 * Searchproducts Input Action
 */
export interface IITSProductsByPartNumbersInput extends Msdyn365.IActionInput {
    itemPartNumber: string;
    strictSearch: boolean;
}
export class SearchproductsInput implements Msdyn365.IActionInput {
    public itemPartNumber: string;
    public strictSearch: boolean;
    // TODO: Construct the input needed to run the action
    constructor(customerAccount: string, strictSearch: boolean) {
        this.itemPartNumber = customerAccount;
        this.strictSearch = strictSearch;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetProductsByPartNumber`;
    public getCacheObjectType = () => 'GetProductsByPartNumber';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductsByPartNumberAction(
    request: IITSProductsByPartNumbersInput,
    ctx: Msdyn365.IActionContext
): Promise<IITSSearchItemPartResponse | null> {
    if (request.itemPartNumber && request.strictSearch) {
        try {
            const result = await getProductsByItemPartNumberAsync({ callerContext: ctx }, request.itemPartNumber, request.strictSearch);
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IITSSearchItemPartResponse>>getProductsByPartNumberAction,
    // TODO: Give your data action a unique id
    id: 'GetProductsByPartNumber'
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
